<template>
  <v-tab-item
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-tab-item>
</template>

<script>
// Transparent wrapper for a single tab's content.
// Vuetify 3 cutover: render v-window-item instead of v-tab-item.
export default {
  name: "EkitabuTabItem",
  inheritAttrs: false,
};
</script>
